import React from "react";
import PropTypes from "prop-types";
import {registerConfirmHandler} from "./ConfirmadorServicio";


export default class ConfirmadorControlador extends React.Component {
    state = {
        options: null,
        resolver: null,
    };

    componentDidMount() {
        registerConfirmHandler((options, resolver) => {
            this.setState({ options, resolver });
        });
    }

    handleYes = () => {
        if (this.state.resolver)
            this.state.resolver(true);
        this.setState({ options: null, resolver: null });
    };

    handleNo = () => {
        if (this.state.resolver)
            this.state.resolver(false);
        this.setState({ options: null, resolver: null });
    };

    render() {
        const { options } = this.state;
        if (!options)
            return null;

        const {
            message,
            okText = "Sí",
            cancelText = "No",
            okStyle = {},
            cancelStyle = {},
        } = options;

        return (
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0,0,0,0.4)",
                    zIndex: 9999,
                }}
            >
                <div
                    style={{
                        backgroundColor: "white",
                        padding: "24px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                        width: "320px",
                    }}
                >
                    <p style={{ marginBottom: "16px", fontSize: "18px" }}>{message}</p>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                        <button
                            onClick={this.handleNo}
                            style={{
                                padding: "8px 16px",
                                backgroundColor: "#e0e0e0",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                ...cancelStyle,
                            }}
                        >
                            {cancelText}
                        </button>
                        <button
                            onClick={this.handleYes}
                            style={{
                                padding: "8px 16px",
                                backgroundColor: "#2563eb",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                ...okStyle,
                            }}
                        >
                            {okText}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

ConfirmadorControlador.propTypes = {
    // no recibe props externas por ahora
};
